/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import Helmet from 'react-helmet';

export default class ClutchWidget extends React.Component {
  componentDidMount() {
    setTimeout(this.initClutch, 500);
  }

  initClutch = () => {
    setTimeout(() => {
      if (
        typeof window !== 'undefined' &&
        window.CLUTCHCO &&
        window.CLUTCHCO.loaded === false
      ) {
        window.CLUTCHCO.Init();
      }
    }, 500);
  };

  render() {
    return (
      <div className="clutch-base">
        <a
          href="https://clutch.co/profile/ulam-labs?utm_source=widget&utm_medium=widget_2&utm_campaign=widget&utm_content=logo"
          className="clutch-replacement"
          aria-label="See Ulam Labs on Clutch"
          target="_blank"
          rel="noopener noreferrer"
          style={{ visibility: 'hidden' }}
        >
          text
        </a>
        <div
          className="clutch-widget"
          data-url="https://widget.clutch.co"
          data-widget-type="2"
          data-height="50"
          data-darkbg="1"
          data-clutchcompany-id="93488"
        />
        <Helmet>
          <script
            type="text/javascript"
            src="https://widget.clutch.co/static/js/widget.js"
            async
            defer
          />
        </Helmet>
      </div>
    );
  }
}
